// extracted by mini-css-extract-plugin
export var sliderRange = "_mo-2";
export var sliderRoot = "_mo-0";
export var sliderThumb = "_mo-3";
export var sliderTrack = "_mo-1";